/** 宫格编辑弹窗：根据列位置返回浮动操作面板对齐 class */
export function getGridPanelAlignClass(index, colCount = 3) {
	if (colCount <= 1) {
		return 'is-align-left';
	}
	const col = index % colCount;
	if (col === 0) {
		return 'is-align-left';
	}
	if (col === colCount - 1) {
		return 'is-align-right';
	}
	return 'is-align-center';
}

/** 浮动操作面板展开时，为网格/列表预留底部空间（px） */
export const EDIT_FLOAT_PANEL_OPEN_PADDING = 44;

/**
 * 将当前选中项的浮动操作面板滚入弹窗滚动容器的可见区域
 */
export function ensureEditFloatPanelVisible(vm, {
	gridRef = 'editGrid',
	wrapSelector,
	panelSelector,
	selectedIndex,
} = {}) {
	const index = selectedIndex ?? vm.selectedIndex;
	if (index == null) return;
	vm.$nextTick(() => {
		const ref = vm.$refs[gridRef];
		const grid = ref?.$el ?? ref;
		if (!grid?.querySelectorAll) return;
		const wraps = grid.querySelectorAll(wrapSelector);
		const panel = wraps[index]?.querySelector(panelSelector);
		panel?.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
	});
}
